<template>
  <div class="flex items-center gap-2">
    <FloatingMenu
      ref="floatingMenu"
      placement="right-end"
      :arrow="true"
      :offset="[0, 10]"
    >
      <template #activator="{ show }">
        <slot :show="show" :user="user" />
      </template>
      <template #content>
        <div
          class="flex items-center gap-2 border-b py-2 pb-3 px-4 hover:bg-light-neutral-300 w-[250px]"
        >
          <div
            class="font-bold border p-5 rounded-full text-primary-500 bg-primary-50 w-5 h-5 text-sm uppercase flex items-center justify-center"
          >
            <div class="flex items-center">
              <p class="font-medium text-base text-primary-500">
                {{ user?.firstName?.charAt(0) }}{{ user?.lastName?.charAt(0) }}
              </p>
            </div>
          </div>
          <div
            class="text-nowrap truncate font-medium text-dark-neutral-500 text-base"
          >
            {{
              user?.firstName
                ? user.firstName.charAt(0).toUpperCase() +
                  user.firstName.slice(1)
                : ''
            }}

            {{
              user?.lastName
                ? user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1)
                : ''
            }}
          </div>
        </div>
        <div>
          <UserSettings v-model="activeStep" />
          <div
            class="font-medium text-error-500 text-base hover:bg-light-neutral-300 px-4 py-1"
          >
            <button
              class="py-2 tracking-wide hover:bg-light-neutral-300 w-full flex gap-2"
              @click="logout"
            >
              <ArrowLeftEndOnRectangleIcon class="size-6" />
              logout
            </button>
          </div>
        </div>
      </template>
    </FloatingMenu>
  </div>
</template>

<script lang="ts" setup>
import FloatingMenu from '@app/components/Global/FloatingMenu.vue'
import { ref } from 'vue'
import { injectStrict } from '@app/utils/injectStrict'
import { AuthKey } from '@app/injectionKeys'
import useWebExtension from '@app/composables/useWebExtension'
import { ArrowLeftEndOnRectangleIcon } from '@heroicons/vue/24/solid'
import UserSettings from './UserSettings.vue'

const { user, logout: authLogout } = injectStrict(AuthKey)
const activeStep = ref(1)
const { logoutExtension } = useWebExtension()

async function logout() {
  authLogout()
  logoutExtension()
}
</script>
